// Partner team naming helpers.
//
// The "Aymeric Pierre" partner team was renamed to "Aypierre" in August 2026.
// The report data still carries both names: pieces created before the rename
// may keep the old creatorName, and the monthly Stats (partnerData /
// partnerRankData) are keyed by whichever name was current that month.
// Every custom computation targeting this team must accept either name.

export const AYPIERRE = "Aypierre";
export const AYPIERRE_NAMES = [AYPIERRE, "Aymeric Pierre"];

// True when a piece's creatorName belongs to the Aypierre team, under either name.
export function isAypierre(creatorName) {
  return AYPIERRE_NAMES.includes(creatorName);
}

// Canonical name, so keys built from creatorName line up across data sources
// (e.g. revenue CSV rows vs. report pieces in MonitorView).
export function normalizeCreatorName(creatorName) {
  return isAypierre(creatorName) ? AYPIERRE : creatorName;
}

// Every name a team entry ({ name, aliases? }) may appear under in the data.
export function teamNames(team) {
  return [team.name, ...(team.aliases || [])];
}

// Purchasable-item count (partnerData[name][0]) for a team in one Stats month,
// summed across all of its names. A month can list both names when the rename
// left a few pieces under the old one.
export function partnerDataCount(partnerData, team) {
  return teamNames(team).reduce((sum, name) => sum + (partnerData?.[name]?.[0] || 0), 0);
}

// A team's rank for one Stats month. When both names are present, the old one
// only holds leftover pieces and a meaningless rank, so keep the best (lowest)
// rank instead of summing. 0 when the team isn't ranked that month.
export function partnerRank(partnerRankData, team) {
  const ranks = teamNames(team)
    .map((name) => partnerRankData?.[name])
    .filter((rank) => rank > 0);
  return ranks.length ? Math.min(...ranks) : 0;
}
